import { render } from "./DialogHasSameTicket.vue?vue&type=template&id=2257ad54"
import script from "./DialogHasSameTicket.vue?vue&type=script&lang=js"
export * from "./DialogHasSameTicket.vue?vue&type=script&lang=js"
script.render = render

export default script